import { useCallback, useEffect, useState } from "react"
import DropZone from "./DropZone"
import shortid from "shortid";
import TextField from '@mui/material/TextField';
import Component from "./Component";
import { arrayMoveImmutable } from 'array-move';
import CancerComponent from "./CancerComponent";
import DemographicComponent from "./DemographicComponent";
import GeneComponent from "./GeneComponent";
import SectionDropZone from "./SectionDropZone";
import TreatmentComponent from "./TreatmentComponent";
import { Button } from "@mui/material";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import './divflat.css';
import Banner from 'react-js-banner';

ChartJS.register(ArcElement, Tooltip, Legend);


function CentralLayout(props) {

    const[showQuery,setShowQuery] = useState(false);
    const[componentList,setcomponentList]= useState([])

    const fontStyleInclusions = {
        "color": "revert",
        "font-weight": "bold",
        "font-size": "larger",
        "text-align": "center"  

    }
    const data = {
  labels: ['Cancer', 'Gene','Treatment'],
  datasets: [
    {
      label: 'Patients',
      data: [203,132,89],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
      ],
      borderWidth: 1,
    },
  ],
};
    var initialData = {
        layout: [
//   {
//     "id": "5wFxlGCg9T",
//     "type": "item",
//     "compType": "PANEL_CANCER",
//     "parameters": [
//       {
//         "textBoxName": "Enter Cancer Type",
//         "textBoxValue": [
//           "Aggressive Angiomyxoma"
//         ]
//       }
//     ]
//   },
//   {
//     "id": "rgrBLJ4hcg",
//     "type": "item",
//     "compType": "PANEL_GENE",
//     "parameters": [
//       {
//         "textBoxName": "Enter Gene Type",
//         "textBoxValue": "miRNA",
//         "textBoxName2": "Alterations",
//         "textBoxValue2": "",
//         "textBoxValue3": "MIR-10A/10A"
//       }
//     ]
//   },
//   {
//     "id": "_L2x9au6lX",
//     "type": "item",
//     "compType": "PANEL_TREATMENT",
//     "parameters": [
//       {
//         "textBoxName": "Enter treatment",
//         "textBoxValue": 3,
//         "textBoxName2": "Selection",
//         "textBoxValue2": "1",
//         "textBoxName3": "Line",
//         "textBoxValue3": 3
//       }
//     ]
//   }
]   
    }
    // Handling dropping of side items into central layout in Inclusions section
    const [inclusionsData, setInclusionsData] = useState(initialData.layout)
    const [funnelDataResetFlag, setfunnelDataResetFlag] = useState(false)
 

    const addInclusionItem = useCallback(
        (item) => {
            // if(inclusionsData.length!=0){
            // console.log("line 106 "+inclusionsData.layout)
            // }
            let arr = []
            let layout = [...inclusionsData, item];
            layout.map(m=>{
                if(!arr.some(it=>it === m.compType)){
                arr.push(m.compType)}
            })
            if(arr.length-1===inclusionsData.length){
            setInclusionsData(layout);
            setfunnelDataResetFlag(true)
            }
        },
        [inclusionsData]
    );



    // Handling dropping of side items into central layout in Exclusions section
    const [exclusionsData, setExclusionsData] = useState(initialData.layout)
    const addExclusionItem = useCallback(
        (item) => {
            let layout = [...exclusionsData, item];
            setExclusionsData(layout);
        },

        [exclusionsData]
    );



    // Handling of components movement in the central layout up and down
    const addComponentItem = useCallback(
        (dropZone, item) => {
            if (dropZone == undefined || item == undefined) {
                return
            }
            let isInclusions = (inclusionsData.findIndex(s => s.id == dropZone.id) != -1) ? true : false
            if (isInclusions) {
                // Moving inclusion elements
                let targetIndex = inclusionsData.findIndex(s => s.id == dropZone.id)
                let initialIndex = inclusionsData.findIndex(s => s.id == item.id)
                targetIndex = initialIndex > targetIndex ? targetIndex + 1 : targetIndex
                targetIndex = targetIndex > inclusionsData.length - 1 ? inclusionsData.length - 1 : targetIndex
                let array2 = arrayMoveImmutable(inclusionsData, initialIndex, targetIndex);
                console.log("updated values", array2)
                setInclusionsData(array2);
            } else {
                // Moving exclusion elements
                let targetIndex = exclusionsData.findIndex(s => s.id == dropZone.id)
                let initialIndex = exclusionsData.findIndex(s => s.id == item.id)
                targetIndex = initialIndex > targetIndex ? targetIndex + 1 : targetIndex
                targetIndex = targetIndex > exclusionsData.length - 1 ? exclusionsData.length - 1 : targetIndex
                let array2 = arrayMoveImmutable(exclusionsData, initialIndex, targetIndex);
                setExclusionsData(array2);
            }
        },
        [inclusionsData, exclusionsData]
    );


    const updateChildValueChange = useCallback((id, newObj) => {
        console.log("updating value on change detection ", id, newObj)
        let isInclusions = (inclusionsData.findIndex(s => s.id == id) != -1) ? true : false
        if (isInclusions) {
            let newInclusionsData = [...inclusionsData]
            let index = newInclusionsData.findIndex(s => s.id == id)

            newInclusionsData[index]['parameters'] = newObj

            // newInclusionsData[index].textBoxValue = value
            setInclusionsData(newInclusionsData)

        } else {
            let newExclusionsData = [...exclusionsData]
            let index = newExclusionsData.findIndex(s => s.id == id)

            Object.keys(newObj).forEach(key => {
                newExclusionsData[index][key] = newObj[key]
            })
            // newInclusionsData[index].textBoxValue = value
            setExclusionsData(newExclusionsData)
        }

    }, [inclusionsData, exclusionsData])

    const [_query, setQuery] = useState("")
    const [showDAta, setshowDAta] = useState(Boolean)

    const getTreamentValuesMapping = (option , index) => {
        if(option == "TREATMENT"){
            if ( index == 1 ) return "Treatment 1"
            if ( index == 2 ) return "Treatment 2"
            if ( index == 3 ) return "Treatment 3"
        }
        if(option == "PHASE"){
            if ( index == 1 ) return "Time of G360"
            if ( index == 2 ) return "Before Tx"
            if ( index == 3 ) return "After Tx"
            if ( index == 4 ) return "Both"
            if ( index == 5 ) return "Any"
        }
        if(option == "LINE"){
            if ( index == 1 ) return "1st Line"
            if ( index == 2 ) return "2nd Line"
            if ( index == 3 ) return "3rd Line"
            if ( index == 4 ) return "Both"
            if ( index == 5 ) return "Any"
        }
    }

    

    const buildQuery2 =()=>
    {
        if(showDAta)
        setshowDAta(false)
        else
            setshowDAta(true)
    }

    const resetLayout =()=>
    {
       setInclusionsData(initialData.layout)
       setfunnelDataResetFlag(false)
    }
        useEffect(() => {
        localStorage.setItem('filterData', JSON.stringify(inclusionsData));
        }, [inclusionsData]);

        props.getData(inclusionsData)
       
        props.getFunnel(funnelDataResetFlag)

        const valuesInRedColour=(data)=>
        {
            return <><p style="color:red">{data}</p></>
        }

    const buildQuery= () => {
        setShowQuery(true)
        if(inclusionsData.length>0)
        {
            setfunnelDataResetFlag(true)
        }
        let query = ""
        inclusionsData.forEach(panel =>{

            if(panel.compType == "PANEL_CANCER"){

                let cancer_query = []

                panel.parameters.forEach(params => {
                    let allVal = 
                    cancer_query.push("( "+ params.textBoxValue.join(" AND ")+ " )")
                })
                query = query + "CANCER is " + cancer_query.join(" OR ") + "; "
            }
            if(panel.compType == "PANEL_GENE"){
                let gene_query = []

                panel.parameters.forEach(params => {
                    gene_query.push("(  GENE's are "+ params.textBoxValue3 +" And mutations are "+params.textBoxValue+ " )" )
                })

                query = query + "GENOME " + gene_query.join(" OR ") + ";  "

            }

            if(panel.compType == "PANEL_TREATMENT"){ 
                let treatment_query = []
           
                panel.parameters.forEach(params => {
                    let q = getTreamentValuesMapping("TREATMENT", params.textBoxValue) + " & " + getTreamentValuesMapping("PHASE", params.textBoxValue2) + " &  " + getTreamentValuesMapping("LINE", params.textBoxValue3)
                    treatment_query.push("( " + q +" )")
                })

                query = query + "TREATMENT is " + treatment_query.join(" OR ") 

            }
        })

        setQuery("Query is :- "+query)
    }

    useEffect(()=>
    {
        buildQuery()
    },[inclusionsData,exclusionsData])

    const doDelete = useCallback((id) => {
        let isInclusions = (inclusionsData.findIndex(s => s.id == id) != -1) ? true : false
        if (isInclusions) {
            console.log("In Line 302")
            let index = inclusionsData.findIndex(s => s.id == id)
            let newInclusionsData = [...inclusionsData]
            newInclusionsData.splice(index, 1)
            setInclusionsData(newInclusionsData);
        }
        else {
            console.log("In Line 306")
            let index = exclusionsData.findIndex(s => s.id == id)
            let newExclusionsData = [...exclusionsData]
            newExclusionsData.splice(index, 1)
            setExclusionsData(newExclusionsData);
        }
    }, [inclusionsData, exclusionsData])



    const buildComponent = (item) => {

        console.log("In Line 318 ", item.id, item.compType, item.parameters)
        
        if (item.compType == "PANEL_CANCER") {
            return (
                <CancerComponent
                    handleDrop={addComponentItem}
                    id={item.id}
                    parameters={item.parameters}
                    onChange={updateChildValueChange}
                    doDelete={doDelete}
                />
            )
        }
        if (item.compType == "PANEL_DEMOGRAPHIC") {
            return (<>
                <DemographicComponent
                    handleDrop={addComponentItem}
                    id={item.id}
                    parameters={item.parameters}
                    onChange={updateChildValueChange}
                    doDelete={doDelete}
                />
                </>
            )
        }
        if (item.compType == "PANEL_GENE") {
            console.log("In Line:- 344"+item.parameters.map(m=>console.log))
            return (
                <GeneComponent
                    handleDrop={addComponentItem}
                    id={item.id}
                    parameters={item.parameters}
                    onChange={updateChildValueChange}
                    doDelete={doDelete}
                />
            )
        }
        if (item.compType == "PANEL_TREATMENT") {
            return (
                <TreatmentComponent
                    handleDrop={addComponentItem}
                    id={item.id}
                    parameters={item.parameters}
                    onChange={updateChildValueChange}
                    doDelete={doDelete}
                />
            )
        }
    }

    return (

        <div>
            <div style={fontStyleInclusions}>COHORT BUILDER</div><br/>
            {inclusionsData.map((item) => {
                return buildComponent(item)
            })}
            {inclusionsData.length!=4 &&<SectionDropZone handleDrop={addInclusionItem} />}

            <div >
            {/* <Button  variant="outlined" onClick={buildQuery}>Build Query</Button><br/><br/> */}
                {/* {<span style={{width:"100%",color:"royalblue"}}>
                <Banner 
                title= {_query}
                css={{ color: "#0096fb", backgroundColor: "white", fontFamily: "arial" ,'justify-content':"left",'text-align':"left"}}
                />
                </span>} */}
                <br/>
                {/* <Button  variant="outlined" onClick={buildQuery2}>Execute Query</Button><br></br> */}
                {funnelDataResetFlag && 
                <Button style={{border:"1px solid black",marginLeft:"45%",borderRadius: "15px"}}  size="medium" onClick={resetLayout}>Reset Query</Button>}
                
                <br></br>
            </div>
        </div>
    )
}

export default CentralLayout;